import React from "react";
import DataTable from "../../../components/common/DataTable";
import { TABLE_COLUMNS } from "../constants/logConstants";

/**
 * TaskLogsTable component displays task execution logs
 *
 * This component renders task logs in a filterable data table format.
 * It applies text filtering to all fields and handles empty log arrays gracefully.
 * Task logs represent system operations and their statuses.
 *
 * @param {Object} props - Component props
 * @param {Array} props.logs - The array of task log entries to display
 * @param {string} props.filterQuery - Text query to filter logs (case-insensitive)
 * @returns {JSX.Element} Rendered data table with formatted task logs
 */
function TaskLogsTable({ logs, filterQuery }) {
  const displayFilteredLogs = () => {
    if (!logs) return [];
    const regex = new RegExp(filterQuery, "i");
    return logs.filter((obj) => regex.test(Object.values(obj)));
  };

  return <DataTable columns={TABLE_COLUMNS.taskLogs} dataRows={displayFilteredLogs()} height={"70vh"} />;
}

export default TaskLogsTable;
